import { render, staticRenderFns } from "./DepositBlock.vue?vue&type=template&id=fc077dca&scoped=true&"
import script from "./DepositBlock.vue?vue&type=script&lang=js&"
export * from "./DepositBlock.vue?vue&type=script&lang=js&"
import style0 from "./DepositBlock.vue?vue&type=style&index=0&id=fc077dca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc077dca",
  null
  
)

export default component.exports